import { BaseModel } from './base-model';
import { ZoneFeature } from './zones-base-interfaces';

// Base class for Balast Water Management zones
export abstract class TerminalGeofencesModelBase extends BaseModel
{
    abstract getTerminalGeofences(): Promise<ZoneFeature[] | null>;
}

let TerminalGeoFencesModel: TerminalGeofencesModelBase|null = null;

function setTerminalGeoFencesModel(model: TerminalGeofencesModelBase)
{
    TerminalGeoFencesModel = model;
}

export { TerminalGeoFencesModel, setTerminalGeoFencesModel };